import React from 'react';
import PropTypes from 'prop-types';

const Link = ({
	fill = '#9b9b9b',
	...props
}) => (
	<svg width="22" height="22" viewBox="0 0 22 22" fill={fill} {...props}>
		<path d="M12.2805587,8.30522774 L12.4,8.18578644 L13.1071068,8.89289322 C15.4976311,11.2834175 15.4976311,15.0165825 13.1071068,17.4071068 L10.3071068,20.2071068 C7.91658249,22.5976311 4.18341751,22.5976311 1.79289322,20.2071068 C-0.597631073,17.8165825 -0.597631073,14.0834175 1.80746817,11.6786127 L5.02885549,8.58608085 L6.41391915,10.0288555 L5.69253183,10.7213873 L3.20710678,13.1071068 C1.59763107,14.7165825 1.59763107,17.1834175 3.20710678,18.7928932 C4.81658249,20.4023689 7.28341751,20.4023689 8.89289322,18.7928932 L11.6928932,15.9928932 C13.0569059,14.6288805 13.2649331,12.6490804 12.3169747,11.0972388 L12.1627907,11.2514229 L11.4556839,10.5443161 C9.51477203,8.60340419 9.51477203,5.56713844 11.4556839,3.62622655 L13.6262266,1.45568392 C15.5671384,-0.485227972 18.6034042,-0.485227972 20.5443161,1.45568392 C22.485228,3.39659581 22.485228,6.43286156 20.5297411,8.38805399 L17.8703693,10.9410509 L16.4853057,9.49827629 L17.206693,8.80574446 L19.1301025,6.95955989 C20.2899658,5.79969658 20.2899658,4.02976078 19.1301025,2.86989748 C17.9702392,1.71003417 16.2003034,1.71003417 15.0404401,2.86989748 L12.8698975,5.04044011 C11.9606181,5.94971948 11.7641719,7.23393946 12.2805587,8.30522774 Z"/>
	</svg>
);

Link.propTypes = {
	fill: PropTypes.string
};

export default Link;
